/**
 * Shell público: Turbo/Stimulus tras el legacy public.
 */
import { ensureLegacyPublic } from '@/legacy/ensure_legacy_public';

await ensureLegacyPublic();
await import('@/apps/cifra/boot_shell_public');
